<template>
  <div>
    <section class="orderSect">
      <!--S 检索-->
      <el-form inline :model="formInline">
        <el-form-item label="订单号" class="codeSerIpt">
          <el-input v-model.trim="formInline.orderno" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model.trim="formInline.cardholdertel" placeholder="请输入手机号码"></el-input>
        </el-form-item>
				<el-form-item label="自提口令码">
				  <el-input v-model.trim="formInline.token" placeholder="请输入自提口令码"></el-input>
				</el-form-item>
        <!-- S 订单状态下拉组件 -->
        <!-- <OrderState :excludeStates="excludeOrderStates" @orderStatusObtain="orderStatusReceive"></OrderState> -->
        <!-- E 订单状态下拉组件 -->
        <!-- S 拆单状态下拉组件 -->
        <!-- <SplitState @splitStateObtain="splitStateReceive"></SplitState> -->
        <!-- E 拆单状态下拉组件 -->
        <el-form-item>
          <el-button type="primary" @click="search(0)">查询</el-button>
        </el-form-item>
        <!-- <el-form-item v-show="orderStyle === 1">
          <el-button @click="search(1)">导出</el-button>
        </el-form-item> -->
        <em class="simpleSearch" @click="highShow = !highShow">{{highShow?'精简筛选':'高级筛选'}}</em>
        <div v-show="highShow">
          <!-- <el-form-item label="订单内容">
            <el-input v-model="formInline.ordercontent" placeholder="请输入订单内容"></el-input>
          </el-form-item> -->
          <el-form-item label="收货/提货人">
            <el-input v-model="formInline.receivername" placeholder="请输入收货/提货人"></el-input>
          </el-form-item>
         <!-- <el-form-item label="省/市">
            <el-input v-model="formInline.provinceorcity" placeholder="请输入省/市"></el-input>
          </el-form-item> -->
          <el-form-item label="预售品牌">
          <!-- 预售品牌下拉组件 S -->
          <PresaleBrandSelect @brandObtain="brandReceive"></PresaleBrandSelect>
          <!-- 预售品牌下拉组件 E -->
          </el-form-item>
          <!-- 配送方下拉组件 S -->
          <!-- <DeliveryAreaSelect @deliveryObtain="deliveryReceive"></DeliveryAreaSelect> -->
          <!-- 配送方下拉组件 E -->
          <!-- S 派单状态下拉组件 -->
          <!-- <DispatchState @dispatchObtain="dispatchReceive"></DispatchState> -->
          <!-- E 派单状态下拉组件 -->
          <!-- S 订单类型下拉组件 -->
          <OrderType @orderTypeObtain="orderTypeReceive"></OrderType>
          <!-- E 订单类型下拉组件 -->
          <!-- S 商品类型下拉组件 -->
          <GoodsType @goodsTypeObtain="goodsTypeReceive"></GoodsType>
          <!-- E 商品类型下拉组件 -->
          <!-- S 终端类型下拉组件 -->
          <TerminalType @terminalTypeObtain="terminalTypeReceive"></TerminalType>
          <!-- E 终端类型下拉组件 -->
					<!-- S 送货方式下拉组件 -->
					<!-- <DeliveryMethod @delimode="delimode"></DeliveryMethod> -->
					<!-- E送货方式下拉组件 -->
          <el-form-item label="提货时间">
            <el-date-picker
              v-model="formInline.submitdate"
              type="daterange"
              range-separater="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="formInline.orderDateOptions"
              :unlink-panels="true"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            :label="pubordprintinfo.expecttitle ? pubordprintinfo.expecttitle : '期望发货日期'"
          >
            <el-date-picker
              v-model="formInline.recvdate"
              type="daterange"
              range-separater="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="formInline.orderDateOptions"
              :unlink-panels="true"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              v-if="(sppsfw||preselfpickchooseapm)"
              v-model="formInline.apm"
              placeholder="请选择"
              class="formTimeSlot"
            >
              <el-option label="全天" value></el-option>
              <el-option :label="(sppsfw&&preselfpickchooseapm)?'中午/上午':preselfpickchooseapm?'上午':'中午'" value="0"></el-option>
              <el-option :label="(sppsfw&&preselfpickchooseapm)?'晚上/下午':preselfpickchooseapm?'下午':'晚上'" value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="提货时间">
            <el-date-picker
              v-model="formInline.thtime"
              type="daterange"
              range-separater="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="formInline.orderDateOptions"
              :unlink-panels="true"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item> -->
        </div>
      </el-form>
      <!--E 检索-->

      <OrderListCore
        ref="order-list-core"
        :orderStyle="orderStyle"
        :serachParam="searchParam"
        :extrOperation="true"
        :highShow="highShow" 
      ></OrderListCore>
    </section>
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Api from "@/apis/api.js";
export default {
  name: "orderPending",
  data() {
    return {
      excludeOrderStates: [],
      pubordprintinfo: null,
      pubconfiginfo: null,
      // 地图配送，0：否；1：开启
      sppsfw: 0,
      preselfpickchooseapm:0,
      // 是否展示高级筛选
      highShow: false,
      orderStyle: 1,
      // 检索
      formInline: {
				token:null, //自提口令码
				//送货方式
				delimode:null,
        // 订单状态
        ordstate: null,
        // 派单状态
        desstate: null,
        // 拆单状态
        seporderstate: null,
        // 订单类型
        ordertype: null,
        // 商品类型
        goodstype: null,
        // 终端类型
        terminaltype: null,
        // 下单时间
        submitdate: [],
        // 期望发货日期
        recvdate: [],
        // 提货时间thstarttime
        thtime: [],
        // 订单号
        orderno: "",
        // 订单内容
        ordercontent: "",
        // 手机号
        cardholdertel: "",
        // 收货人/提货人
        receivername: "",
        // 省/市
        provinceorcity: "",
        // 预售品牌
        brandcode: "",
        // 配送方
        regioncode: "",
        // 全天、中午、晚上时间段选择
        apm: null,
        orderDateOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        }
      },
      searchParam: null
    };
  },
  components: {
    // 配送方下拉组件
    DeliveryAreaSelect: resolve =>
      require(["@/components/common/DeliveryAreaSelect.vue"], resolve),
    // 预售品牌下拉组件
    PresaleBrandSelect: resolve =>
      require(["@/components/common/PresaleBrandSelect.vue"], resolve),
    // 订单状态下拉组件
    OrderState: resolve =>
      require(["@/components/Gadget/OrderState.vue"], resolve),
    // 拆单状态下拉组件
    SplitState: resolve =>
      require(["@/components/Gadget/SplitState.vue"], resolve),
    // 派单状态下拉组件
    DispatchState: resolve =>
      require(["@/components/Gadget/DispatchState.vue"], resolve),
    // 订单类型下拉组件
    OrderType: resolve =>
      require(["@/components/Gadget/OrderType.vue"], resolve),
    // 商品类型下拉组件
    GoodsType: resolve =>
      require(["@/components/Gadget/GoodsType.vue"], resolve),
    // 终端类型下拉组件
    TerminalType: resolve =>
      require(["@/components/Gadget/TerminalType.vue"], resolve),
			// 送货方式下拉组件
		DeliveryMethod: resolve =>
			require(["@/components/Gadget/DeliveryMethod.vue"], resolve),
    // 订单列表
    OrderListCore: resolve => require(["./Core/OrderListCore.vue"], resolve)
  },
  methods: {
    // 订单状态下拉选择值
    orderStatusReceive(value) {
      this.formInline.ordstate = value;
    },
    // 拆单状态下拉选择值
    splitStateReceive(value) {
      this.formInline.seporderstate = value;
    },
    // 派单状态下拉选择值
    dispatchReceive(value) {
      this.formInline.desstate = value;
    },
    // 订单类型下拉选择值
    orderTypeReceive(value) {
      this.formInline.ordertype = value;
    },
    // 商品类型下拉选择值
    goodsTypeReceive(value) {
      this.formInline.goodstype = value;
    },
    // 终端类型下拉选择值
    terminalTypeReceive(value) {
      this.formInline.terminaltype = value;
    },
		// 送货方式下拉选择值
		delimode(value) {
			console.log(value, 'sss')
		  this.formInline.delimode = value;
		},
    // 配送方下拉选择值
    deliveryReceive(value) {
      this.formInline.regioncode = value;
    },
    // 预售品牌下拉选择值
    brandReceive(value) {
      this.formInline.brandcode = value;
    },
    // 动态获取表格高度
    // getHeight() {},
    // 检索
    search: function(isexportout) {
      let param = {};
      param.gtype = this.orderStyle;
      Object.assign(param, this.formInline);
      delete param.submitdate;
      delete param.recvdate;
      delete param.thtime;

      if (this.formInline.submitdate && this.formInline.submitdate.length > 0) {
        param.thstarttime = this.formInline.submitdate[0];
        param.thendtime = this.formInline.submitdate[1];
      }

      if (this.formInline.recvdate && this.formInline.recvdate.length > 0) {
        param.startRecvdate = this.formInline.recvdate[0];
        param.endRecvdate = this.formInline.recvdate[1];
      }

      if (this.formInline.thtime && this.formInline.thtime.length > 0) {
        param.thstarttime = this.formInline.thtime[0];
        param.thendtime = this.formInline.thtime[1];
      }
      if (isexportout === 1) {
        param.isexport = true;
        param.exceltype = 0;
      }

      delete param.orderDateOptions;
      this.searchParam = param;
    }
  },
  created() {
    // 页面浏览器视窗变化绑定resize事件
    // window.addEventListener("resize", this.getHeight);
    // 订单服务配置
    this.pubordprintinfo = this.config.getPubordprintinfo();
    // 公共服务配置
    let pubconfiginfo = this.config.getPubconfiginfo();
    this.pubconfiginfo = pubconfiginfo;

    // 是否开通地图配送0：否；1：是
    this.sppsfw = Number(this.ElementControls('sppsfw'));
    this.preselfpickchooseapm = Number(this.ElementControls('preselfpickchooseapm'));
    
  },
  filters: {},
  watch: {
  },
  mounted() {
    if (this.orderStyle === 1) {
      this.excludeOrderStates = [2, 3, 4, 5, 6, 7, 8];
    }

    this.search();
  }
};
</script>

<style scoped>
@import "../OrderFolder/Css/Style.css";

/*发货方弹窗*/
.shipperDlog >>> .el-dialog {
  width: 750px;
}
.shipperDlog >>> .el-radio {
  padding: 20px;
}
.shipperTable {
  color: #666;
}

/*高级修改弹窗*/
.seniorMdg >>> .el-dialog {
  width: 500px;
}
.seniorMdg >>> .el-form-item__content {
  width: 65%;
  min-width: 200px;
  max-width: 340px;
}
.seniorMdg >>> .el-form-item__content .el-select {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/DeliveryFolder/orderPending.vue